
import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import { ProductionLogService } from './production-log.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { LotNumberReportResponseModel, ProductionLogDetailsResponseModel, ProductionLogResponse, SubPlantTransferResponse } from '@gtpl/shared-models/production-management';
import { ProductionLogData } from './dto/production-log.dto';
import { LogIdRequest } from './dto/log-id-request';
import { LotInfoRequest } from './dto/lot-info.request';
import { UnitRequest } from './dto/unit.id.request';
import { CommonResponse } from '@gtpl/shared-models/masters';


@ApiTags('prod-log')
@Controller('prod-log')
export class ProductionLogController {
    constructor(
        private productionLogService: ProductionLogService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
    
    @Post('/createProdLog')
    async createProdLog(@Body() prodLogDto: ProductionLogData): Promise<ProductionLogResponse> {
    try {
        return await this.productionLogService.CreateProductionLog(prodLogDto);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(ProductionLogResponse, error);
      }
    }

    @Post('/getLogDetailsForId')
    async getLogDetailsForId(@Body() prodLogDto: LogIdRequest): Promise<SubPlantTransferResponse> {
    try {
        return await this.productionLogService.getLogDetailsForId(prodLogDto.productionLogid);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(SubPlantTransferResponse, error);
      }
    }
    @Post('/getLotTrackingReportData')
  async getLotTrackingReportData(@Body() req: LotInfoRequest): Promise<LotNumberReportResponseModel> {
    try {
      return await this.productionLogService.getLotTrackingReportData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotNumberReportResponseModel, error);
    }
  }
    @Post('/getSubPlantHistoryDetails')
  async getSubPlantHistoryDetails(@Body() req: UnitRequest): Promise<ProductionLogDetailsResponseModel> {
    try {
      return await this.productionLogService.getSubPlantHistoryDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ProductionLogDetailsResponseModel, error);
    }
  }

  @Post('/getTransactionDetails')
  async getTransactionDetails(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getTransactionDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
}